import {AiToolImpl} from "@me8eon/aiclient";
import {mustBeObjectWithFields} from "@me8eon/validate";
import {ElasticSearchConfig} from "@me8eon/ai.tools.utils";
import {createStringFromOrderItCategoryHits} from "./utils/createStringFromOrderItCategoryHits";
import {fetchOrderItElasticSearchWithDeviceTypeFilter} from "./utils/fetchOrderItElasticSearchWithDeviceTypeFilter";
import {JwtTokenFn} from "@me8eon/authentication";

type ToolArgs = {}

type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (config: ElasticSearchConfig, jwtTokenFn: JwtTokenFn) => ToolImpl

export const FetchAllLaptopsDetailsList: Tool = (esConfig, jwtTokenFn) => {
    return {
        type: "fetch_all_laptops_details_list",
        toolDefn: {
            type: 'function',
            name: "fetch_all_laptops_details_list",
            description: "This tool fetches list of laptops that are possible to order with their details, including: price, cost type (single/monthly/both/free), delivery time, technical specifications. It will list only top 15 items. It does not take any input parameters.",
            parameters: {
                type: "object",
                required: [],
                additionalProperties: false,
                properties: {}
            },
        },
        validateArgs: mustBeObjectWithFields({}),
        execute: async (indices, _input) => {
            try {
                const response = await fetchOrderItElasticSearchWithDeviceTypeFilter(esConfig, indices,"laptop", jwtTokenFn);

                return {
                    value: createStringFromOrderItCategoryHits(response.data.hits.hits),
                    _meta: {
                        rawResponse: response.data,
                    }
                }

            } catch (e: any) {
                return {
                    value: "An error occurred while fetching the list of laptops.",
                    _meta: {
                        error: String(e),
                    }
                };
            }
        }
    };
};

